import '.f{width:100%;}.ssr-plugin'
import '.am{height:100%;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.ac{flex-direction:column;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.fs{min-height:44px;}.ssr-plugin'
import '.ft{padding:0 16px 0 12px;}.ssr-plugin'
import '.bk{gap:8px;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.cw{margin-left:auto;}.ssr-plugin'
import '.fu{overflow-y:auto;}.ssr-plugin'
import '.fv{overflow-x:hidden;}.ssr-plugin'
import '.eo{gap:2px;}.ssr-plugin'
import '.a1{gap:4px;}.ssr-plugin'
import { useState } from 'react'
import { ItemActions } from '../../utils/common.js'
import { Text } from '../Text/index.js'
import { IconButton } from '../IconButton/index.js'
import { CheckboxInput } from '../CheckboxInput/index.js'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { Icon, IconProps } from '../Icon/index.js'
import { ListItem } from './ListItem.js'
import { Style, styled } from 'inlines'

type ListProps = {
  data: any[]
  fields: Record<any, any>
  flushItems?: boolean
  title?: string
  select?: any
  cleanMode?: boolean
  onSelectChange?: (select?: any) => void
  collapsible?: boolean
  onItemClick?: (item: any) => void
  itemActions?: ItemActions
  placeholder?: string
  placeholderIcon?: IconProps['variant']
  disabled?: boolean
  error?: boolean
  onOrderChange?: (draggedId: string, targetIdx: number) => void
  onRemove?: (item: any) => void
  style?: Style
}

function List({
  title,
  collapsible,
  onSelectChange,
  data,
  select,
  cleanMode,
  fields,
  flushItems,
  onItemClick,
  onOrderChange,
  itemActions,
  placeholder,
  placeholderIcon,
  error,
  disabled,
  onRemove,
  style,
}: ListProps) {
  const [collapsed, setCollapsed] = useState(false)

  return (
    <styled.div className="f am a ac"
      style={{
        ...style,
      }}
    >
      {title && !cleanMode && (
        <styled.div className="a d fs ft bk"
          style={{
            border: `1px solid ${colors.neutral20Adjusted}`,
            background: colors.neutral5,
            borderTopLeftRadius: radius[20],
            borderTopRightRadius: radius[20],
            ...(collapsed && {
              borderBottomLeftRadius: radius[20],
              borderBottomRightRadius: radius[20],
            }),
          }}
        >
          {onSelectChange && (
            <CheckboxInput
              size="small"
              value={select?.length === data?.length}
              onChange={() => {
                if (select?.length !== data?.length) {
                  onSelectChange(data)
                } else {
                  onSelectChange(undefined)
                }
              }}
            />
          )}
          <Text variant="display-medium" color="neutral80">
            {title}
          </Text>
          {collapsible && (
            <div className="a c d cw"
            >
              <IconButton
                size="small"
                icon={collapsed ? 'chevron-left' : 'chevron-down'}
                onClick={() => {
                  setCollapsed((p) => !p)
                }}
              />
            </div>
          )}
        </styled.div>
      )}
      {!collapsed && (
        <styled.div className="am fu fv eo a ac"
          style={{
            padding: flushItems ? undefined : 8,
            ...(!cleanMode && {
              borderLeft: `1px solid ${colors.neutral20Adjusted}`,
              borderRight: `1px solid ${colors.neutral20Adjusted}`,
              borderBottom: `1px solid ${colors.neutral20Adjusted}`,
              borderBottomLeftRadius: radius[20],
              borderBottomRightRadius: radius[20],
              ...(!title && {
                borderTop: `1px solid ${colors.neutral20Adjusted}`,
                borderTopLeftRadius: radius[20],
                borderTopRightRadius: radius[20],
              }),
            }),
            ...(error && {
              borderLeft: `1px solid ${colors.red80}`,
              borderRight: `1px solid ${colors.red80}`,
              borderBottom: `1px solid ${colors.red80}`,
              ...(!title && {
                borderTop: `1px solid ${colors.red80}`,
              }),
            }),
            ...(disabled && {
              cursor: 'not-allowed',
              color: colors.neutral20,
              background: colors.neutral5,
              borderLeft: `1px solid transparent`,
              borderRight: `1px solid transparent`,
              borderBottom: `1px solid transparent`,
              ...(!title && {
                borderTop: `1px solid transparent`,
              }),
            }),
          }}
        >
          {data?.length > 0 ? (
            data.map((item, idx) => (
              <ListItem
                key={`${idx}-${item?.id}`}
                idx={idx}
                item={item}
                disabled={disabled}
                fields={fields}
                flushItems={flushItems}
                cleanMode={cleanMode}
                selected={!!select?.find(({ id }) => id === item?.id)}
                onClick={onItemClick && (() => onItemClick(item))}
                onSelectChange={
                  onSelectChange &&
                  ((selected) => {
                    onSelectChange(
                      selected
                        ? [...(select ?? []), item]
                        : select?.filter(({ id }) => id !== item.id),
                    )
                  })
                }
                itemActions={itemActions}
                onOrderChange={onOrderChange}
                onRemove={onRemove}
              />
            ))
          ) : (
            <div className="f am c d a ac a1"
              style={{
                color: colors.neutral60,
              }}
            >
              {placeholderIcon && <Icon variant={placeholderIcon} />}
              {placeholder && (
                <Text variant="subtext-medium" color="inherit">
                  {placeholder}
                </Text>
              )}
            </div>
          )}
        </styled.div>
      )}
    </styled.div>
  )
}

export { List }
export type { ListProps }
